import React from 'react';
import '../App.css';
import TimeAgo from 'react-timeago';


export default class Notification extends React.Component {

  constructor(props) {
    // console.log('[Notification] constructor called...');
    super(props);
    if (props && props.data) {
      this.state = {message: this.props.data};
    }
  }

  showProfile(event, user) {
    console.log('[Notification] showProfile called on Notificiation...');
    event.preventDefault();
    // Set post to empty or the App will show the last post shown in teh timeline
    // if one has been shown.  Unclean but we can clean this up later. It's front end
    // stuff after all :)
    this.props.app.setState({profile: user, post: ''});
  }

  showPost(e, data) {
    e.preventDefault();
    if (data.post) {
      this.props.app.showPost(data.post);
    }
  }

  render() {
    let className = 'notification', originator = '', points = 0;
    if (this.props.data && this.props.data.vote) {
      originator = <div>{this.props.data.vote.user.username}</div>;
    } else if (this.props.data && this.props.data.comment) {
      originator = <div>{this.props.data.comment.user.username}</div>;
    }
    let img = '';
    if (this.props.data && this.props.data.user) {
      img = <img className='avatar' src={this.props.data.user.avatar} alt='' />;
    } else if (this.props.data.vote && this.props.data.vote.user) {
      img = <img className='avatar' src={this.props.data.vote.user.avatar} alt='' />;
    } else if (this.props.data.comment && this.props.data.comment.user) {
      img = <img className='avatar' src={this.props.data.comment.user.avatar} alt='' />;
    }
    let notificationBody = '';
    if (this.props.data) {
      let prefix = '';
      let itemText = '';
      if (this.props.data.vote) {
        if (this.props.data.vote.direction === 'up') {
          points = this.props.data.vote.points
          prefix = ' concordou com: ';
        } else {
          points = ( this.props.data.vote.points * -1 )
          prefix = ' reagiu para: ';
        }
      } else if (this.props.data.comment) {
        prefix = ' fez um comentario: ';
        if (this.props.data.comment.comment_id) {
          // this is a reply to a comment..
          prefix = ' respondeu para: ';
        }
      } 
      if (this.props.data.comment) {
        itemText = this.props.data.comment.text;
      } else if (this.props.data.post) {
        if (this.props.data.poll_response_count && !this.props.data.vote_id) {
          itemText = 'Você tem ' + this.props.data.poll_response_count + ' respostas para sua post: ' + this.props.data.post.title;
        } else {
          itemText = this.props.data.post.title;
        }
      }
      notificationBody = <span>{prefix} <b>{itemText}</b></span>;
    }
    return (
      <div id='notf' onClick={(e) => this.showPost(e, this.props.data)}>
        <div className={className}>
          {img || ''}
          <div className='notificationInterior'>
            {originator}
            {notificationBody}
            {(this.props.data.post && this.props.data.post.image_url && this.props.data.post.image_url.indexOf('missing.png') === -1) ? <img src={this.props.data.post.image_url} alt='' className='avatar' style={{'float': 'right'}} /> : ''}
            {(points > 0 || points < 0) ? <span className={points > 0 ? 'pointSpanPos' : 'pointSpanNeg'}><i> {points > 0 ? "+" : ""}{points}</i></span> : ''}
            <br />
            <TimeAgo className='smallGreyFont' date={this.props.data['created_at']} />
          </div>
        </div>
      </div>
    );
  }
}

